import * as React from 'react';
import './checkout.css';
// import Button from '../custom_components/button/button.component';
import { StoreState, CustomAction } from '../store';
import { Dispatch, bindActionCreators } from 'redux';
import { selectGeneric } from '../store/actions/generic.actions';
import { Signup_Obj } from '../store/reducers/signup_input.reducers';
import { connect } from 'react-redux';
// import { withRouter } from 'react-router';
import { Signup_Details_Obj } from '../store/reducers/signup_details.reducers';
import { Checkout_Stage_Obj } from '../store/reducers/checkout_stage.reducers';

import CheckoutA from './checkout_a.component';
// import CheckoutB from './checkout_b.component';
// import CheckoutC from './checkout_c.component';
import CheckoutD from './checkout_d.component';
import CheckoutE from './checkout_e.component';
// import CheckoutNo from './checkout_no.component';
import { Current_Stage_Obj } from '../store/reducers/current_checkout_stage.reducers';
import { History } from 'history';

// import Button from '../custom_components/button/button.component';

export interface Checkout_Props {
    signup_form: Signup_Obj;
    signup_details: Signup_Details_Obj;
    checkout_stage: Checkout_Stage_Obj;
    current_stage: Current_Stage_Obj;

    updateForm: Function;
    updateStage: Function;
}

export interface Country_Obj {
    name: string;
    short_name: string;
    code: string;
}

// const country_list: Country_Obj[] = [
//     {name: 'Sri Lanka', short_name: 'LK', code: '+94'},
//     {name: 'India', short_name: 'IN', code: '+91'},
//     {name: 'Bangladesh', short_name: 'BD', code: '+880'}
// ];

class Checkout extends React.PureComponent<Checkout_Props> {

    title_text: string = 'Almost done';
    sub_title_text: string = 'Let us know a little bit more about you so that we can move forward.';
    trial_text: string = 'This information will help us create an account for you and get in touch if needed.';

    componentDidMount() {

    }

    render() {

        return (
            <div className="checkout-main">
                {
                    (this.props.current_stage.stage == '1') ?
                    <CheckoutA checkout={this.props.checkout_stage['1']}></CheckoutA>
                    :
                    (this.props.current_stage.stage == '2' ?
                    <CheckoutD checkout={this.props.checkout_stage['2']}></CheckoutD>
                    :
                    <CheckoutE checkout={this.props.checkout_stage['3']}></CheckoutE>)
                }
                <div>
                    {/* <img src={back_photo} className="checkout-graphics-background" alt="background" /> */}
                    {/* a person holding an umbrella under a rain of data (leave, clocks, letters)*/}
                </div>
            </div>
        )
    }

    emailInput = (event: any) => {
        let re = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");
        
        let email_validity: boolean = re.test(event.target.value);
        
        let updated_form: Signup_Obj = {
            value: event.target.value,
            valid: email_validity
        }
        this.props.updateForm('SIGNUP_UPDATE', updated_form)

        if (email_validity) {
            let fresh_details: Signup_Details_Obj = {
                ...this.props.signup_details,
                email: event.target.value
            };
    
            this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)
        }
    }

    formInput = (field_name: string, event: any) => {
        let fresh_details: Signup_Details_Obj = {
            ...this.props.signup_details,
            [field_name]: event.target.value
        };

        this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)
    }

    submitForm = (history: History, event: any) => {
        let fresh_details: Signup_Details_Obj = {
            ...this.props.signup_details,
            email: this.props.signup_form.value
        };

        this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)

        history.push('/pricing')
    }
}

export function mapStateToProps({ signup_form, signup_details, checkout_stage, current_checkout_stage }: StoreState) {
    return {
      signup_form: signup_form,
      signup_details: signup_details,
      checkout_stage: checkout_stage,
      current_stage: current_checkout_stage
    }
}
  
export function mapDispatchToProps(dispatch: Dispatch<CustomAction>) {
    return bindActionCreators({
        updateForm: selectGeneric,
        updateStage: selectGeneric
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);


// WEBPACK FOOTER //
// ./src/checkout/checkout.component.tsx